<template>
  <div class="content">
    <div class="content-header">
      <h3>{{t.allWorks.dvd}}</h3>
    </div>
    <div class="content static-page" v-if="static_content('dvd')" v-html="static_content('dvd')"></div>
    <template v-else>
      <div class="spinner">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['t', 'static_content'])
  },
};
</script>

<style lang="scss" scoped>
.content {
  line-height: 26px;
  color: #444;
  p {
    text-align: left;
  }
}
</style>